import { Component } from '@angular/core';

@Component({
  selector: 'itfg-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  standalone: false,
})
export class DashboardComponent {}
